// extracted by mini-css-extract-plugin
export default {"wrapper":"SegmentedSnippet_wrapper--RxU","page":"SegmentedSnippet_page--n0D","header":"SegmentedSnippet_header--aHz","content":"SegmentedSnippet_content--Hd1"};